var productMeasurementSelector = {
  
    incrementLength: 0.05,
    initialPrice: parseFloat($('.product__price').text().replace('£', '')),

    init: function() {

      this.quantityControl();
      this.quantityIncrease();
      this.quantityDecrease();
    },
  
    updateQuantity: function(value, wrapper) {
        var roundedValue = parseFloat((Math.ceil(value * (1 / this.incrementLength)) * this.incrementLength).toFixed(2));
        var hiddenInput =  wrapper.find('.product-measurement-selector__hidden');
        hiddenInput.val(parseFloat((roundedValue / this.incrementLength).toFixed(2)));
        
        if (parseFloat(hiddenInput.attr('max')) < parseFloat(hiddenInput.val())) {
            hiddenInput.val(hiddenInput.attr('max'));
            hiddenInput.trigger('change');
            wrapper.find('.product-measurement-selector__input').val(hiddenInput.val()*this.incrementLength);
            return hiddenInput.val()*this.incrementLength;
        }

        hiddenInput.trigger('change');
        wrapper.find('.product-measurement-selector__input').val(roundedValue);
        return roundedValue;
    },
  
    quantityControl: function() {
      var self = this;
      jQuery(document).on('change', '.product-measurement-selector__input', function(){
        var wrapper = jQuery(this).parents(".product-measurement-selector__wrapper");
        var value = parseFloat($(this).val());
        var minLength = self.minLength(jQuery(this));
        value = isNaN(value)?minLength:value;
        if(value < minLength) {
            value = minLength;
        }
        self.updateQuantity(value, wrapper);
      });
    },
  
    quantityIncrease: function() {
      var self = this;
      jQuery(document).on('click', '.product-measurement-selector__incr', function(){
        var wrapper = jQuery(this).parents(".product-measurement-selector__wrapper");
        var inputField = $(this).siblings('input[type="number"]');
        var hiddenInput =  wrapper.find('.product-measurement-selector__hidden');

        if(parseFloat(hiddenInput.attr('max')) == hiddenInput.val()){
            return;
        }

        var currentValue = parseFloat(inputField.val());
        var newValue = parseFloat((currentValue + self.incrementLength).toFixed(2));
        self.updateQuantity(newValue, wrapper);
      });
    },

    quantityDecrease: function() {
        var self = this;
        jQuery(document).on('click', '.product-measurement-selector__decr', function(){
          var wrapper = jQuery(this).parents(".product-measurement-selector__wrapper");
          var inputField = $(this).siblings('input[type="number"]');
          var currentValue = parseFloat(inputField.val());
          var newValue = parseFloat((currentValue - self.incrementLength).toFixed(2));
          var minLength = self.minLength(inputField);
          if(newValue < minLength){
            return;
          }

          self.updateQuantity(newValue, wrapper);
        });
    }, 

    minLength: function(inputField) {
      return parseFloat(inputField.attr('min'));
    }

  };
  
  jQuery(document).ready(function() {
    productMeasurementSelector.init();
  });
  